/**
 * ProgressPage - Main page for progress tracking dashboard
 *
 * Features:
 * - Class-level progress overview
 * - Student progress view
 * - Outcome progress view
 * - Responsive mobile-first design
 */

import { ProgressDashboard } from "@/components/progress";
import { TrendingUp } from "lucide-react";

export default function ProgressPage() {
  return (
    <div className="container mx-auto p-4 sm:p-6 max-w-5xl">
      {/* Header */}
      <div className="space-y-2 mb-6">
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight flex items-center gap-2">
          <TrendingUp className="h-7 w-7" />
          Progress Tracking
        </h1>
        <p className="text-muted-foreground">
          Monitor student progress and curriculum outcome mastery
        </p>
      </div>

      {/* Main Dashboard */}
      <ProgressDashboard />
    </div>
  );
}
